const t = {
  name: "Experiments1",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 2H5.99995V4H7.49995V11.2314L3.87256 17.4969C2.71467 19.4969 4.15785 22 6.46884 22H17.5311C19.8421 22 21.2852 19.4969 20.1273 17.4969L16.5 11.2314V4H18V2ZM9.49995 11.7686V4H14.5V11.7686L15.7918 14H8.20808L9.49995 11.7686ZM7.05019 16H16.9497L18.3965 18.499C18.7824 19.1656 18.3014 20 17.5311 20H6.46884C5.69851 20 5.21745 19.1656 5.60342 18.499L7.05019 16Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Experiments1
};
